import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { analyzeDream } from '../api/dream';
import { useLanguage } from '../contexts/LanguageContext';

export default function DreamPage() {
  const { language } = useLanguage();
  const [dreamInput, setDreamInput] = useState('');
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!dreamInput.trim()) return;

    setLoading(true);
    setError(null);
    setResults(null);

    try {
      const data = await analyzeDream(dreamInput);
      setResults(data.results);
    } catch (err) {
      setError(language === 'zh' ? '分析失败，请稍后重试。' : 'Analysis failed, please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="dream-page-container" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ marginBottom: '20px', fontSize: '24px', fontWeight: '600' }}>
          {language === 'zh' ? '周公解梦' : 'Dream Interpretation'}
        </h1>
        
        <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '16px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
          <p style={{ marginBottom: '16px', color: '#666' }}>
            {language === 'zh' 
              ? '请输入您的梦境关键词或简短描述（例如：梦见蛇、飞翔、掉大牙）。' 
              : 'Please enter keywords or a short description of your dream (e.g., snake, flying, teeth falling out).'}
          </p>

          <form onSubmit={handleSubmit}>
            <textarea
              value={dreamInput}
              onChange={(e) => setDreamInput(e.target.value)}
              placeholder={language === 'zh' ? '在此输入梦境...' : 'Describe your dream here...'}
              style={{
                width: '100%',
                minHeight: '120px',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #ddd',
                marginBottom: '16px',
                fontSize: '16px',
                fontFamily: 'inherit',
                resize: 'vertical'
              }}
            />
            
            <button 
              type="submit" 
              disabled={loading}
              style={{
                padding: '10px 24px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '500',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading 
                ? (language === 'zh' ? '分析中...' : 'Analyzing...') 
                : (language === 'zh' ? '解梦' : 'Interpret Dream')}
            </button>
          </form>

          {error && (
            <div style={{ marginTop: '20px', padding: '12px', backgroundColor: '#fff0f0', color: '#d32f2f', borderRadius: '8px' }}>
              {error}
            </div>
          )}

          {results && (
            <div style={{ marginTop: '30px' }}>
              <h3 style={{ fontSize: '18px', marginBottom: '16px', borderBottom: '1px solid #eee', paddingBottom: '8px' }}>
                {language === 'zh' ? '解析结果' : 'Interpretation Results'}
              </h3>
              
              {results.length > 0 ? (
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  {results.map((result, index) => (
                    <li key={index} style={{ marginBottom: '16px', padding: '16px', backgroundColor: '#f8f9fa', borderRadius: '8px', lineHeight: '1.6' }}>
                      {result}
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={{ color: '#666' }}>
                  {language === 'zh' ? '未找到相关解释。' : 'No interpretation found.'}
                </p>
              )}
            </div>
          )}
        </div>
        
        <div style={{ marginTop: '30px', fontSize: '14px', color: '#999', textAlign: 'center' }}>
          {language === 'zh' ? '注：解梦结果仅供娱乐参考。' : 'Note: Interpretations are for entertainment purposes only.'}
        </div>
      </div>
    </DashboardLayout>
  );
}
